module.exports = __webpack_public_path__ + "img/Shiba-BG.3db0fbd9.jpg";